import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { getParticipantById } from '../../../base/participants/functions';
import ContextMenuItemGroup from '../../../base/ui/components/web/ContextMenuItemGroup';
import { setFrequencyFilterSetting, setParticipantBrightness, setParticipantContrast, setParticipantOpacitySetting, setParticipantSaturation, setParticipantZoomLevel, setVolume } from '../../../filmstrip/actions.web';
import { getParticipantsBrightnessByParticipantId, getParticipantsContrastByParticipantId, getParticipantsFrequencySettingByParticipantId, getParticipantsOpacityByParticipantId, getParticipantsSaturationByParticipantId, getParticipantsVolumeByParticipantId, getParticipantsZoomByParticipantId } from '../../../filmstrip/functions.web';
import BrightnessSlider from './BrightnessSlider';
import ContrastSlider from './ContrastSlider';
import FrequencyFilterSlider from './FrequencyFilterSlider';
import OpacityAdjustSlider from './OpacityAdjustSlider';
import SaturationSlider from './SaturationSlider';
import VolumeSlider from './VolumeSlider';
import ZoomSlider from './ZoomSlider';
const VideoSettingsContextMenu = ({ participant, opacity, soundControl, brightness, zoom, saturation, volume, contrast, frequency }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const _onVolumeChange = (value) => {
        if (participant) {
            dispatch(setVolume(participant.id, value));
        }
    };
    const _onFrequencyAdjustChange = (value) => {
        if (participant) {
            dispatch(setFrequencyFilterSetting(participant.id, value));
        }
    };
    const _onBrightnessChange = (value) => {
        if (participant) {
            dispatch(setParticipantBrightness(participant.id, value));
        }
    };
    const _onContrastChange = (value) => {
        if (participant) {
            dispatch(setParticipantContrast(participant.id, value));
        }
    };
    const _onParticipantOpacityAdjustChange = (value) => {
        if (participant) {
            dispatch(setParticipantOpacitySetting(participant.id, value));
        }
    };
    const _onSaturationChange = (value) => {
        if (participant) {
            dispatch(setParticipantSaturation(participant.id, value));
        }
    };
    const _onZoomLevelChange = (value) => {
        if (participant) {
            dispatch(setParticipantZoomLevel(participant.id, value));
        }
    };
    return (React.createElement(React.Fragment, null,
        soundControl && (React.createElement(ContextMenuItemGroup, null,
            React.createElement(VolumeSlider, { initialValue: volume ?? 0, key: 'volume-slider', label: t('volumeSlider'), onChange: _onVolumeChange }),
            React.createElement(FrequencyFilterSlider, { initialValue: frequency ?? 0, key: 'frequency-adjust-slider', label: t('settings.audioSettings.highFrequencies'), onChange: _onFrequencyAdjustChange }))),
        React.createElement(ContextMenuItemGroup, null,
            React.createElement(ContrastSlider, { initialValue: contrast ?? 0, key: 'cotrast-slider', label: t('contrastSlider'), onChange: _onContrastChange }),
            React.createElement(BrightnessSlider, { initialValue: brightness ?? 0, key: 'brightness-slider', label: t('brightnessSlider'), onChange: _onBrightnessChange }),
            React.createElement(OpacityAdjustSlider, { initialValue: opacity ?? 0, key: 'opacity-adjust-slider', label: t('opacityAdjustSlider'), onChange: _onParticipantOpacityAdjustChange }),
            React.createElement(SaturationSlider, { initialValue: saturation ?? 0, key: 'saturation-slider', label: t('saturationSlider'), onChange: _onSaturationChange }),
            React.createElement(ZoomSlider, { initialValue: zoom ?? 0, key: 'zoom-slider', label: t('zoomSlider'), onChange: _onZoomLevelChange }))));
};
const mapStateToProps = (state, ownProps) => {
    const { participantId } = ownProps;
    const participant = getParticipantById(state, participantId ?? '');
    return {
        participant,
        brightness: participant ? getParticipantsBrightnessByParticipantId(state, participant?.id) : 0,
        contrast: participant ? getParticipantsContrastByParticipantId(state, participant?.id) : 0,
        saturation: participant ? getParticipantsSaturationByParticipantId(state, participant?.id) : 0,
        opacity: participant ? getParticipantsOpacityByParticipantId(state, participant?.id) : 0,
        zoom: participant ? getParticipantsZoomByParticipantId(state, participant?.id) : 0,
        frequency: participant ? getParticipantsFrequencySettingByParticipantId(state, participant?.id) : 0,
        volume: participant ? getParticipantsVolumeByParticipantId(state, participant?.id) : 0
    };
};
export default connect(mapStateToProps)(VideoSettingsContextMenu);
